// authTypes
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const AUTH_INIT_START  = "AUTH_INIT_START";
export const AUTH_INIT_FINISH = "AUTH_INIT_FINISH";

// projectActions
export const FETCH_PROJECTS_REQUEST = 'FETCH_PROJECTS_REQUEST';
export const FETCH_PROJECTS_SUCCESS = 'FETCH_PROJECTS_SUCCESS';
export const FETCH_PROJECTS_FAILURE = 'FETCH_PROJECTS_FAILURE';
// projectDetails
export const PROJECT_DETAILS_REQUEST = 'PROJECT_DETAILS_REQUEST';
export const PROJECT_DETAILS_SUCCESS = 'PROJECT_DETAILS_SUCCESS';
export const PROJECT_DETAILS_FAILURE = 'PROJECT_DETAILS_FAILURE';
// fatch all employee details
export const FETCH_EMPLOYEES_REQUEST = "FETCH_EMPLOYEES_REQUEST";
export const FETCH_EMPLOYEES_SUCCESS = "FETCH_EMPLOYEES_SUCCESS";
export const FETCH_EMPLOYEES_FAILURE = "FETCH_EMPLOYEES_FAILURE";
// resend activation email
export const RESEND_ACTIVATION_REQUEST = "RESEND_ACTIVATION_REQUEST";
export const RESEND_ACTIVATION_SUCCESS = "RESEND_ACTIVATION_SUCCESS";
export const RESEND_ACTIVATION_FAILURE = "RESEND_ACTIVATION_FAILURE";
//fatch all clients details
export const FETCH_CLIENTS_REQUEST = "FETCH_CLIENTS_REQUEST";
export const FETCH_CLIENTS_SUCCESS = "FETCH_CLIENTS_SUCCESS";
export const FETCH_CLIENTS_FAILURE = "FETCH_CLIENTS_FAILURE";
// fatch client details
export const CLIENT_DETAILS_REQUEST = 'CLIENT_DETAILS_REQUEST';
export const CLIENT_DETAILS_SUCCESS = 'CLIENT_DETAILS_SUCCESS';

export const CLIENT_DETAILS_FAILURE = 'CLIENT_DETAILS_FAILURE';
// fatch user role list
export const USER_ROLE_REQUEST = 'USER_ROLE_REQUEST';
export const USER_ROLE_SUCCESS = 'USER_ROLE_SUCCESS';
export const USER_ROLE_FAILURE = 'USER_ROLE_FAILURE';
//FETCH USER PERMISSION LIST
export const FETCH_USER_PERMISSIONS_REQUEST = "FETCH_USER_PERMISSIONS_REQUEST";
export const FETCH_USER_PERMISSIONS_SUCCESS = "FETCH_USER_PERMISSIONS_SUCCESS";
export const FETCH_USER_PERMISSIONS_FAILURE = "FETCH_USER_PERMISSIONS_FAILURE";

//GET EMAIL ADDRESS FROM USER FOR FORGOT PASSWORD
export const GET_USER_FORGOT_EMAIL_REQUEST = 'GET_USER_FORGOT_EMAIL_REQUEST';
export const GET_USER_FORGOT_EMAIL_SUCCESS = 'GET_USER_FORGOT_EMAIL_SUCCESS';
export const GET_USER_FORGOT_EMAIL_FAILURE = 'GET_USER_FORGOT_EMAIL_FAILURE';
//GET EMAIL ADDRESS FROM USER FOR FORGOT PASSWORD AUTH TOKEN
export const GET_USER_FORGOT_AUTH_REQUEST = 'GET_USER_FORGOT_AUTH_REQUEST';
export const GET_USER_FORGOT_AUTH_SUCCESS = 'GET_USER_FORGOT_AUTH_SUCCESS';
export const GET_USER_FORGOT_AUTH_FAILURE = 'GET_USER_FORGOT_AUTH_FAILURE';
//CHANGE THE PASSWORD AFTER TOKEN VERIFY
export const USER_FORGOT_PASS_CHANGE_REQUEST = 'USER_FORGOT_PASS_CHANGE_REQUEST';
export const USER_FORGOT_PASS_CHANGE_SUCCESS = 'USER_FORGOT_PASS_CHANGE_SUCCESS';
export const USER_FORGOT_PASS_CHANGE_FAILURE = 'USER_FORGOT_PASS_CHANGE_FAILURE';

//get MY task list
export const GET_MY_TASKS_REQUEST = "GET_MY_TASKS_REQUEST";
export const GET_MY_TASKS_SUCCESS = "GET_MY_TASKS_SUCCESS";
export const GET_MY_TASKS_FAILURE = "GET_MY_TASKS_FAILURE";

export const GET_ALL_EMP_TASKS_REQUEST = "GET_ALL_EMP_TASKS_REQUEST";
export const GET_ALL_EMP_TASKS_SUCCESS = "GET_ALL_EMP_TASKS_SUCCESS";
export const GET_ALL_EMP_TASKS_FAILURE = "GET_ALL_EMP_TASKS_FAILURE";
//timesheet releted actions
export const GET_WEEKLY_TS_REQUEST = "GET_WEEKLY_TS_REQUEST";
export const GET_WEEKLY_TS_SUCCESS = "GET_WEEKLY_TS_SUCCESS";
export const GET_WEEKLY_TS_FAILURE = "GET_WEEKLY_TS_FAILURE";

export const GET_EMP_WEEKLY_TS_REQUEST = "GET_EMP_WEEKLY_TS_REQUEST";
export const GET_EMP_WEEKLY_TS_SUCCESS = "GET_EMP_WEEKLY_TS_SUCCESS";
export const GET_EMP_WEEKLY_TS_FAILURE = "GET_EMP_WEEKLY_TS_FAILURE";

export const GET_EACH_WEEKLY_TS_REQUEST = "GET_EACH_WEEKLY_TS_REQUEST";
export const GET_EACH_WEEKLY_TS_SUCCESS = "GET_EACH_WEEKLY_TS_SUCCESS";
export const GET_EACH_WEEKLY_TS_FAILURE = "GET_EACH_WEEKLY_TS_FAILURE";

export const USER_CHANGE_PASSWORD_REQUEST = 'USER_CHANGE_PASSWORD_REQUEST';
export const USER_CHANGE_PASSWORD_SUCCESS = 'USER_CHANGE_PASSWORD_SUCCESS';
export const USER_CHANGE_PASSWORD_FAILURE = 'USER_CHANGE_PASSWORD_FAILURE';

//invoice related actions
export const FETCH_INVOICES_REQUEST = 'FETCH_INVOICES_REQUEST';
export const FETCH_INVOICES_SUCCESS = 'FETCH_INVOICES_SUCCESS';
export const FETCH_INVOICES_FAILURE = 'FETCH_INVOICES_FAILURE';

export const CREATE_INVOICE_REQUEST = 'CREATE_INVOICE_REQUEST';
export const CREATE_INVOICE_SUCCESS = 'CREATE_INVOICE_SUCCESS';
export const CREATE_INVOICE_FAILURE = 'CREATE_INVOICE_FAILURE';

export const INVOICE_DETAIL_REQUEST = 'INVOICE_DETAIL_REQUEST';
export const INVOICE_DETAIL_SUCCESS = 'INVOICE_DETAIL_SUCCESS';
export const INVOICE_DETAIL_FAILURE = 'INVOICE_DETAIL_FAILURE';

export const UPDATE_INVOICE_REQUEST = 'UPDATE_INVOICE_REQUEST';
export const UPDATE_INVOICE_SUCCESS = 'UPDATE_INVOICE_SUCCESS';
export const UPDATE_INVOICE_FAILURE = 'UPDATE_INVOICE_FAILURE';

export const DELETE_INVOICE_REQUEST = 'DELETE_INVOICE_REQUEST';
export const DELETE_INVOICE_SUCCESS = 'DELETE_INVOICE_SUCCESS';
export const DELETE_INVOICE_FAILURE = 'DELETE_INVOICE_FAILURE';

// project file upload actions
export const UPLOAD_PROJECT_FILE_REQUEST = 'UPLOAD_PROJECT_FILE_REQUEST';
export const UPLOAD_PROJECT_FILE_SUCCESS = 'UPLOAD_PROJECT_FILE_SUCCESS';
export const UPLOAD_PROJECT_FILE_FAILURE = 'UPLOAD_PROJECT_FILE_FAILURE';
// clear uploaded files (UI reset)
export const CLEAR_UPLOADED_FILES = 'CLEAR_UPLOADED_FILES';
// remove a single uploaded file from upload state
export const REMOVE_UPLOADED_FILE = 'REMOVE_UPLOADED_FILE';
// profile file upload actions
export const UPLOAD_PROFILE_FILE_REQUEST = 'UPLOAD_PROFILE_FILE_REQUEST';
export const UPLOAD_PROFILE_FILE_SUCCESS = 'UPLOAD_PROFILE_FILE_SUCCESS';
export const UPLOAD_PROFILE_FILE_FAILURE = 'UPLOAD_PROFILE_FILE_FAILURE';
